import React from "react";
import { useMutation } from "@apollo/client";

import { RemoveModal } from "components/modal/remove";
import {
  archiveTeamMember,
  archiveTeamMemberVariables,
  restoreTeamMember,
  restoreTeamMemberVariables,
  getTeamByOrgId_organization_team as User,
} from "types/gql-types";

import { ARCHIVE_USER_MUTATION, RESTORE_USER_MUTATION } from "./query";

type Props = {
  user: User;
};

const ERROR_TEXT =
  "Unable to {action} this user. Please try again or contact support@havenconnect.com.";
const CONFIRMATION_TEXT = "Are you sure you want to {action} {user}?";

export const ArchiveUser: React.FC<Props> = ({ user }) => {
  const [archiveUser] = useMutation<archiveTeamMember, archiveTeamMemberVariables>(
    ARCHIVE_USER_MUTATION,
  );
  const [restoreUser] = useMutation<restoreTeamMember, restoreTeamMemberVariables>(
    RESTORE_USER_MUTATION,
  );

  const action = () => {
    const selectedAction = user.isArchived ? restoreUser : archiveUser;
    return selectedAction({
      variables: { id: user.id },
      refetchQueries: ["getTeamByOrgId"],
    });
  };

  const buttonText = user.isArchived ? "Restore" : "Archive";
  const actionText = user.isArchived ? "restore" : "archive";
  const removalText = CONFIRMATION_TEXT
    .replace("{action}", actionText)
    .replace("{user}", user.fullName || "");
  const errorText = ERROR_TEXT.replace("{action}", actionText);
  const secondaryMessage = user.isArchived ? " " : "Archived users cannot log in to the system.";
  return (
    <RemoveModal
      action={action}
      buttonText={buttonText}
      removalText={removalText}
      errorText={errorText}
      secondaryMessage={secondaryMessage}
    />
  );
};
